import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CheckOutlined from '@mui/icons-material/CheckOutlined';

import { setSuccessMessage } from '../../../store/formsState';

import app from '../../../app.module.css';
import success from './messageBanners.module.css';

const SuccessSnackbar = () => {
    const dispatch = useDispatch();

    const WAIT = 5000;
    const [isOpen, setIsOpen] = useState(false);

    const message = useSelector((state) => state.entities.formsState.successMessage);

    useEffect(() => {
        setIsOpen(message.length > 0);
    }, [message]);

    useEffect(() => {
        if (!isOpen) return;
        const el = document.getElementById('successMessageEl');
        let fadeoutTimeoutId;
        el && (fadeoutTimeoutId = setTimeout(() => el.classList.add(`${app.fadeout}`), WAIT - 500));
        const timeoutId = setTimeout(() => onClose(), WAIT);
        return () => {
            clearTimeout(timeoutId);
            if(el) clearTimeout(fadeoutTimeoutId);
        };
    }, [isOpen]);

    const onClose = () => {
        dispatch(setSuccessMessage(''));
    };

    return !isOpen ? null : (
        <div
            id="successMessageEl"
            className={`${success.bannerWrapper} ${success.successWrapper} ${app.fadein}`}
            onClick={onClose}>
            <CheckOutlined /> {message}
        </div>
    );
};

export default SuccessSnackbar;
